export const TSizes = {
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 24,
  xl: 32,
  xxl: 40,
  xxxl: 48,
  defaultSpace: 12,
  defaultPaddingSpace: 20,
  spaceBtwItems: 12,
  spaceBtwSections: 24,
  spaceBtwTitleSub: 20,
  spaceBtwInputField: 20,
  radiusXS: 4,
  radiusSM: 8,
  radiusMD: 12,
  radiusLG: 20,
  radiusXL: 24,
  radius2XL: 32,
  radiusPill: 999,
  cardRadiusXs: 4,
  cardRadiusSm: 10,
  cardRadiusMd: 12,
  cardRadiusLg: 20,
  cardElevation: 2,
  fontSizeXS: 12,
  fontSizeSm: 14,
  fontSizeMd: 16,
  fontSizeLg: 18,
  fontSizeXL: 20,
  fontSize2XL: 24,
  fontSize3XL: 28,
  fontSize4XL: 32,
  lhTight: 1.1,
  lhSnug: 1.25,
  lhNormal: 1.4,
  lhRelaxed: 1.6,
  iconXs: 12,
  iconSm: 20,
  iconMd: 24,
  iconLg: 32,
  iconXl: 40,
  minTouch: 44,
  buttonHeightSm: 36,
  buttonHeightMd: 44,
  buttonHeightLg: 52,
  buttonRadius: 12,
  buttonWidthMin: 120,
  appBarHeightSm: 48,
  appBarHeight: 56,
  appBarHeightLg: 64,
  listTileHeight: 56,
  listDividerHeight: 1,
  imageThumbSize: 80,
  productImageSize: 120,
  productImageHeight: 160,
  productImageRadius: 20,
  imageCarouselHeight: 220,
  gridGutterXS: 8,
  gridGutterSM: 12,
  gridGutterMD: 16,
  gridGutterLG: 20,
  gridGutterXL: 24,
  gridColsMobile: 2,
  gridColsTablet: 3,
  gridColsDesktop: 4,
  containerSm: 540,
  containerMd: 720,
  containerLg: 960,
  containerXl: 1140,
  container2Xl: 1320,
  mobileScreenSize: 360,
  tabletScreenSize: 768,
  desktopScreenSize: 1366,
  wideScreenSize: 1536,
  customScreenSize: 1100,
  overlayBlur: 12,
  overlayOpacity: 0.5,
  bottomSheetCorner: 24,
  dialogCorner: 20,
  loadingIndicatorSizeSm: 24,
  loadingIndicatorSize: 36,
  loadingIndicatorSizeLg: 48,
  progressBarHeight: 4,
  elevation0: 0,
  elevation1: 1,
  elevation2: 3,
  elevation3: 6,
  elevation4: 8,
  elevation5: 12,
  fieldHeightSm: 40,
  fieldHeightMd: 48,
  fieldHeightLg: 56,
  fieldRadius: 12,
  chipRadius: 24,
  tabHeight: 48,
  bottomNavHeight: 56,
  dividerHeight: 1,
  hairline: 0.5,
};
